module.exports = __webpack_public_path__ + "assets/fonts/opensans-regular_5a69ecd.woff2";